import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import ConnectWallet from "./ConnectWallet";

const Menu = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFixed, setIsFixed] = useState(false);

  const isActive = (sectionId) => {
    if (location.pathname !== "/") return false;
    const section = document.getElementById(sectionId);
    if (!section) return false;
    const rect = section.getBoundingClientRect();
    return rect.top <= 100 && rect.bottom >= 100;
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleMenuClick = (e, sectionId) => {
    e.preventDefault();
    setIsMenuOpen(false);

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        scrollToSection(sectionId);
      }, 100);
    } else {
      scrollToSection(sectionId);
    }
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const headerHeight = 98;
      const sectionTop = section.offsetTop - headerHeight;
      window.scrollTo({
        top: sectionTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <header
      id="header_main"
      className={`header ${isFixed ? "is-fixed is-small" : ""}`}
    >
      <div className="container big">
        <div className="row">
          <div className="col-12">
            <div className="header__body">
              <div className="header__logo">
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  <img
                    id="site-logo"
                    src="/images/logo/logo.png"
                    alt="CVMech"
                    width="100"
                    height="100"
                    data-retina="/images/logo/logo@2x.png"
                    data-width="100"
                    data-height="100"
                    style={{ aspectRatio: "1 / 1", objectFit: "contain" }}
                  />
                </a>
              </div>

              <div className="header__right">
                <nav
                  id="main-nav"
                  className={`main-nav ${isMenuOpen ? "active" : ""}`}
                >
                  <ul id="menu-primary-menu" className="menu">
                    <li
                      className={`menu-item ${
                        isActive("banner") ? "menu-current-item" : ""
                      }`}
                    >
                      <a
                        href="#banner"
                        onClick={(e) => handleMenuClick(e, "banner")}
                      >
                        Home
                      </a>
                    </li>

                    <li
                      className={`menu-item ${
                        isActive("about") ? "menu-current-item" : ""
                      }`}
                    >
                      <a
                        href="#about"
                        onClick={(e) => handleMenuClick(e, "about")}
                      >
                        About
                      </a>
                    </li>
                    <li
                      className={`menu-item ${
                        isActive("project") ? "menu-current-item" : ""
                      }`}
                    >
                      <a
                        href="#project"
                        onClick={(e) => handleMenuClick(e, "project")}
                      >
                        Collection
                      </a>
                    </li>
                    {/* <li
                      className={`menu-item ${isActive("roadmap") ? "menu-current-item" : ""
                        }`}
                    >
                      <a
                        href="#roadmap"
                        onClick={(e) => handleMenuClick(e, "roadmap")}
                      >
                        RoadMap
                      </a>
                    </li> */}
                    {/* <li
                      className={`menu-item ${
                        isActive("team") ? "menu-current-item" : ""
                      }`}
                    >
                      <a
                        href="#team"
                        onClick={(e) => handleMenuClick(e, "team")}
                      >
                        Artist
                      </a>
                    </li> */}
                    <li
                      className={`menu-item ${
                        location.pathname === "/mission"
                          ? "menu-current-item"
                          : ""
                      }`}
                    >
                      <Link to="/mission" onClick={() => setIsMenuOpen(false)}>
                        Mission
                      </Link>
                    </li>
                    <li
                      className={`menu-item ${
                        location.pathname === "/wallet-checker"
                          ? "menu-current-item"
                          : ""
                      }`}
                    >
                      <Link
                        to="/wallet-checker"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        Wallet Checker
                      </Link>
                    </li>
                    <li
                      className={`menu-item ${
                        location.pathname === "/free-mint"
                          ? "menu-current-item"
                          : ""
                      }`}
                    >
                      <Link
                        to="/free-mint"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        Free Mint
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
              <div
                className={`mobile-button ${isMenuOpen ? "active" : ""}`}
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                <span></span>
              </div>

              <div className="header__action">
                <div className="header-wallet">
                  <ConnectWallet />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Menu;
